import { ObsessedEngineeringOrder } from "./obsessed-engineering-order.model";
import { DisplayObsessedEngineeringProduct } from "./obsessed-engineering-product.model";

export interface ObsessedEngineeringOrderedProduct {
	id: string;
	obsessedEngineeringOrderId: string;
	productId: string;
	qty: number;
	metalsProjectIds: string[];
	createdById: string;
	createdOn: Date;
	updatedById: string;
	updatedOn: Date;
}

export interface DisplayObsessedEngineeringOrderedProduct {
	orderedProduct: ObsessedEngineeringOrderedProduct;
	order: ObsessedEngineeringOrder;
	product: DisplayObsessedEngineeringProduct;
}

export function toDisplayObsessedEngineeringOrderedProducts(
	orderedProducts: ObsessedEngineeringOrderedProduct[],
	productDict: Record<string, DisplayObsessedEngineeringProduct>,
	orderDict: Record<string, ObsessedEngineeringOrder>,
): DisplayObsessedEngineeringOrderedProduct[] {
	return orderedProducts.flatMap((orderedProduct) => {
		const order = orderDict[orderedProduct.obsessedEngineeringOrderId];
		const product = productDict[orderedProduct.productId];

		if (!order || !product) {
			return [];
		}

		return [{
			orderedProduct,
			order,
			product,
		}];
	});
}
